import styled, { css } from "styled-components";
import { DhlButton } from "@dhl-official/react-library";
import { breakpoints, grid } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";

export const ieWeightContent = css`
  @media screen and (min-width: ${breakpoints.tablet}) {
    display: inline-block;
    width: 19%;
  }

  @supports (display: grid) {
    @media screen and (min-width: ${breakpoints.tablet}) {
      display: flex;
      width: 100%;
    }
  }
`;

export const WeightContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: var(--dui-size-space-10x) 0 0;
  margin-left: ${grid.columns.width.s};
  margin-right: ${grid.columns.width.s};
  ${ieWeightContent}

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-bottom: 0;
    padding-top: 0;
    margin-left: 0;
    margin-right: 0;
  }

  @supports (display: grid) {
    grid-row: weightRow;
    grid-column: 1 / span 12;

    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-area: weightCol;
      padding-right: var(--gaq-size-space-52px);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      grid-row: dimensionsRow;
      grid-area: weightCol;
      padding-right: 0;
    }
  }

  @media print {
    width: 30%;
    padding: 0px;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--dui-size-space-6x);
`;

export const WeightInputWrapper = styled.div`
  max-width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 200px;
  }
  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: 100%;
  }
`;

export const StyledFeedbackMessageButton = styled(DhlButton)`
  display: block;
  margin-top: var(--dui-size-space-5x);
  & > .styled:is(button) {
    text-decoration: underline;
    padding: 0 !important;
    line-height: var(--dui-size-line-height-sm) !important;
    height: auto !important;
    font-weight: 400 !important;
    padding: 0 !important;
    text-align: left;
    font-size: var(--dui-size-font-sm) !important;
  }
`;
